window.mwApoInit = window.mwApoInit || {};
window.mwApoInit._handlers = window.mwApoInit._handlers || [];

const originalOnEvent = window.mwApoInit.onEvent;
window.mwApoInit.onEvent = function (event, args) {
  if (originalOnEvent) {
    originalOnEvent(event, args);
  }

  window.mwApoInit._handlers.forEach(fn => fn(event, args));
};

window.mwApoInit._handlers.push((event, args) => {
  if (event === "init::finish") {
    initCheckboxPopovers();
  }
});

function createCheckboxPopover() {
  const popover = document.createElement('div');
  popover.id = 'CheckboxDescriptionPopover';
  popover.className = 'checkbox-popover relative';

  popover.innerHTML = `
    <div class="checkbox-popover__content">
      <button aria-label="Close" class="btn btn--plain checkbox-popover__close" id="checkboxPopoverClose">X</button>
      <div class="text-base checkbox-popover__text" id="checkboxPopoverContent"></div>
    </div>
  `;

  document.body.appendChild(popover);
  return popover;
}

function showCheckboxDescription(description, checkbox) {
  let popover = document.getElementById('CheckboxDescriptionPopover');
  if (!popover) {
    popover = createCheckboxPopover();
  }

  const content = popover.querySelector('#checkboxPopoverContent');
  content.innerHTML = description;

  const rect = checkbox.getBoundingClientRect();
  popover.style.position = 'absolute';
  popover.style.top = `${rect.bottom + 10 + window.scrollY}px`;
  popover.style.left = `${rect.left + 10 + window.scrollX}px`;

  popover.setAttribute('data-open', 'true');

  const closeBtn = popover.querySelector('#checkboxPopoverClose');
  closeBtn.onclick = () => {
    popover.setAttribute('data-open', 'false');
  };
}

function initCheckboxPopovers() {
  const checkboxes = document.querySelectorAll('.mw-option--type-checkbox input[type="checkbox"]');
  if (!checkboxes.length) {
    return;
  }

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      const id = checkbox.value;

      let description = null;
      if (typeof mwApoInit.response !== 'undefined') {
        for (const val of Object.values(mwApoInit.response)) {
          for (const key in val.values) {
            if (key === id && val.values[id].value?.description) {
              description = val.values[id].value.description;
            }
          }
        }
      }

      if (!description) {
        return;
      }

      if (checkbox.checked) {
        showCheckboxDescription(description, checkbox);
      } else {
        const popover = document.getElementById('CheckboxDescriptionPopover');
        if (popover) {
          popover.setAttribute('data-open', 'false');
        }
      }
    });
  });
}
